import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { GoogleMapsProvider } from './context/GoogleMapsContext'; // Import the new provider
import ProtectedRoute from './components/ProtectedRoute';

import SignInPage from './pages/SignInPage';
import OverviewPage from './pages/OverviewPage';
import LocationsTopListPage from "./pages/LocationsTopListPage";
import LocationsTopFormPage from "./pages/LocationsTopFormPage";
import LocationsMainListPage from "./pages/LocationsMainListPage";
import LocationsMainFormPage from "./pages/LocationsMainFormPage";
import LocationsSubListPage from "./pages/LocationsSubListPage";
import LocationsSubFormPage from "./pages/LocationsSubFormPage";
import LocationsGooglePage from './pages/LocationsGooglePage';
import GooglePlaceForm from './pages/GooglePlaceForm';
import LocationsGoogleBusinessPage from "./pages/LocationsGoogleBusinessPage";
import UsersPage from './pages/UsersPage';
import AuthorizeUserPage from './pages/AuthorizeUserPage';
import MapPublicPage from "./pages/MapPublicPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        {/* Wrap everything inside GoogleMapsProvider. 
            This ensures the script loads once for the whole app.
        */}
        <GoogleMapsProvider>
          <Routes>
            {/* Public Route */}
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/public-map/:id" element={<MapPublicPage />} />    
            
            {/* Protected Routes Wrapper */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<OverviewPage />} />
              
              {/* Google Locations */}
              <Route path="/locations-google" element={<LocationsGooglePage />} />
              <Route path="/google-places/new" element={<GooglePlaceForm />} />
              <Route path="/google-places/:id/edit" element={<GooglePlaceForm />} />
              
              {/* Top Locations */}
              <Route path="/locations-top" element={<LocationsTopListPage />} />
              <Route path="/locations-top/new" element={<LocationsTopFormPage />} />
              <Route path="/locations-top/:id/edit" element={<LocationsTopFormPage />} />
              
              {/* Main Locations */}
              <Route path="/locations-main" element={<LocationsMainListPage />} />
              <Route path="/locations-main/new" element={<LocationsMainFormPage />} />
              <Route path="/locations-main/:id/edit" element={<LocationsMainFormPage />} />
              <Route path="/google-business" element={<LocationsGoogleBusinessPage />} />
              
              {/* Sub Locations */}
              <Route path="/locations-sub" element={<LocationsSubListPage />} />
              <Route path="/locations-sub/new" element={<LocationsSubFormPage />} />
              <Route path="/locations-sub/:id/edit" element={<LocationsSubFormPage />} />
              
              {/* User Management */}
              <Route path="/users" element={<UsersPage />} />
              <Route path="/users/authorize" element={<AuthorizeUserPage />} />
              <Route path="/users/:id/edit" element={<AuthorizeUserPage />} /> 
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </GoogleMapsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;